module.exports = __webpack_public_path__ + "static/media/IconTemplates_-48.cd6435fd.svg";